
import Loading from 'vux/src/components/loading/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'

export default {
components: {
Loading,
XHeader,
XButton,
Group,
Checker,
CheckerItem,
XTextarea,
Icon,
CheckIcon
},
data () {
return {
loading: true,
text: '加载中',
type: 0,
invenstemType: '',
data: {
userInvestmentExperience: {
checked: ''
},
userAssetsScale: {
checked: ''
},
isControllingShareholder: {
checked: '',
description: ''
},
transactionActualBeneficiary: {
checked: '',
description: ''
},
isBadFaith: {
checked: '',
description: ''
}
}
}
},
watch: {
'data.userAssetsScale.checked': function (val, oldVal) {
if (val === '否') {
this.$_personal_toast(oldVal)
}
}
},
created () {
this.$vux.loading.show({text: '加载中'})
this.$bridge.registerHandler('getUpdate', this.$_personal_update)
this.$_personal_init()
},
mounted () {
let _this = this
_this.$bridge.callHandler('getUserInfo', {message: '获取投资者类型'}, (res) => {
let data = JSON.parse(res)
if (data.invenstemType) {
_this.invenstemType = data.invenstemType
}
})
},
methods: {

$_personal_update () {
this.type = 1
},
$_personal_init () {
let _this = this
setTimeout(() => {
_this.type = parseInt(this.$route.query.type)
_this.data.userInvestmentExperience.checked = parseInt(this.$route.query.isNormal) === 1 ? '否' : '是'
if (_this.$route.query.oldInfo) {
let res = JSON.parse(this.$route.query.oldInfo)
this.data = {
userInvestmentExperience: {
checked: JSON.parse(res.userInvestmentExperience).checked
},
userAssetsScale: {
checked: JSON.parse(res.userAssetsScale).checked
},
isControllingShareholder: {
checked: JSON.parse(res.isControllingShareholder).checked,
description: JSON.parse(res.isControllingShareholder).description
},
transactionActualBeneficiary: {
checked: JSON.parse(res.transactionActualBeneficiary).checked,
description: JSON.parse(res.transactionActualBeneficiary).description
},
isBadFaith: {
checked: JSON.parse(res.isBadFaith).checked,
description: JSON.parse(res.isBadFaith).description
}
}
}
_this.loading = false
_this.$vux.loading.hide()
}, 500)
},
$_personal_submit () {
for (var item in this.data) {
if (this.data[item].checked === '') {
this.$vux.toast.show({
type: 'warn',
text: '选择为空或输入不合规范'
})
return
}
let isControllingShareholder = item === 'isControllingShareholder' && this.data[item].checked === '是' && this.data[item].description === ''
let transactionActualBeneficiary = item === 'transactionActualBeneficiary' && this.data[item].checked === '他人' && this.data[item].description === ''
let isBadFaith = item === 'isBadFaith' && this.data[item].checked === '是' && this.data[item].description === ''
if (isControllingShareholder || transactionActualBeneficiary || isBadFaith) {
this.$vux.toast.show({
type: 'warn',
text: '请输入说明内容'
})
return
}
}
this.$_personal_commit(Object.assign({}, this.data, this.$route.query))
},
$_personal_commit (json) {
delete json.oldInfo
delete json.type
delete json.isNormal
if (this.isDev) {
console.log(JSON.stringify(json))
} else {
this.$bridge.callHandler('getResult', {message: '最后确认', json: JSON.stringify(json)}, function (data) {
console.log('submit')
})
}
},
$_personal_toast (oldVal) {
let _this = this
let str = ''
if (this.type === 1) {

if (_this.invenstemType === 'SPECIFIC_PERSONAL_PRACTITIONERS') {
str = '据《私募投资基金募集行为管理办法》32条规定，此项选“否”，将标记该投资者为“投资于所管理私募基金的私募基金管理人的从业人员”，即当然合格投资者，后续无需签署合格投资者承诺函'
} else {
str = '根据《证券期货投资者适当性管理办法》第十四条“一定时期”的规定，私募基金合格投资者必须满足该条件，若您确认选否，该投资者则不符合私募基金购买条件，我们将终止本投资者信息表的填写'
}
this.$vux.alert.show({
title: '提示',
content: str,
onHide () {

if (_this.invenstemType !== 'SPECIFIC_PERSONAL_PRACTITIONERS') {
_this.data.userAssetsScale.checked = oldVal
}
}
})
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/InvestorInfo/Personal/Question.vue